import { DashboardLayout } from "@/components/layouts";
import { authMiddleware } from "@/middleware";
import { AdminUserDetail } from "@/pages/admin/users";
import { createFileRoute } from "@tanstack/react-router";

interface UserDetailSearch {
	email?: string;
}

export const Route = createFileRoute("/_dashboard/admin/users/$userId")({
	component: RouteComponent,
	loader: ({ location }) => authMiddleware(location.pathname),
	validateSearch: (search: Record<string, unknown>): UserDetailSearch => ({
		email: typeof search.email === "string" ? search.email : undefined,
	}),
});

function RouteComponent() {
	const { userId } = Route.useParams();
	const { email } = Route.useSearch();
	return (
		<DashboardLayout>
			<AdminUserDetail userId={userId} email={email} />
		</DashboardLayout>
	);
}
